import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { H3 } from 'foundations-components/transitional/components/H3';
import PracticalExerciseCondensedWrapper from './PracticalExerciseCondensedWrapper';
import PracticalExerciseProgressFeedback from './PracticalExerciseProgressFeedback';
import PracticalExerciseStartButton from './PracticalExerciseStartButton';
import { useLoadPracticalExerciseSurvey } from '../practicalExerciseHooks';
import { useIsSimulationExercise } from '../practicalExerciseQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompletedPracticalExerciseCondensed = ({
  advanceToNextContent,
  allowRevisitExercise = false,
  contentId,
  handleSetExerciseContext,
  lessonId,
  trackId
}) => {
  const {
    isSimulationExercise
  } = useIsSimulationExercise(contentId);
  useLoadPracticalExerciseSurvey({
    skip: !isSimulationExercise
  });
  return /*#__PURE__*/_jsx(PracticalExerciseCondensedWrapper, {
    buttons: /*#__PURE__*/_jsxs(_Fragment, {
      children: [allowRevisitExercise && /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(PracticalExerciseStartButton, {
          contentId: contentId,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.revisitExercise"
          }),
          lessonId: lessonId,
          onStartClick: handleSetExerciseContext,
          trackId: trackId,
          use: "secondary"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: advanceToNextContent,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.continue"
        })
      })]
    }),
    children: /*#__PURE__*/_jsxs(PracticalExerciseProgressFeedback, {
      pictogramName: "CelebrationSuccess",
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.statusTitle.completed"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.statusSubtitle.completed"
      })]
    })
  });
};
export default CompletedPracticalExerciseCondensed;